import React, {FC, Fragment, ReactNode} from 'react'
import BreadcrumbHeader from "../BreadcrumbHeader";
import CustomProduct from "./CustomProduct";
import {ICurrencies} from "../Wrappers/MainLayout";
import {IProduct, TranslationsType} from "../../../types/homePageTypes";
import {ICustomerGroupPrices, IRequestFormDetails} from "../../../pages/[productSlug]";
import CustomConfig from "./CustomConfig";
import CustomDownloadableProduct from "./CustomDownloadableProduct";
import CustomRelatedBlock from "./CustomRelatedBlock";
import BuilderSection from "../../builder/BuilderDataRender";
import CustomBundle from "./CustomBundle";
import FormModal from "../../builder/Button/FormModal";
import {useSelector} from "react-redux";
import {IState} from "../../../types/state";
import {IFormComponentType} from "../../builder/types";

interface ICustomShopProduct {
    dbName: string;
    domain: string;
    productSlug: string;
    selectedRate: ICurrencies;
    product: IProduct;
    backOrderValue: string;
    customerGroupPrices: Array<ICustomerGroupPrices>;
    translationsData: TranslationsType;
    selectedLocale: string;
    schemaBrandName: string;
    showDetailsInFront: boolean;
    breadcrumb: Array<{ title: string; url: string }>;
    relatedProducts: Array<IProduct>,
    selectedCurrItems: {
        selectedCurrCode: string;
        selectedCurrRate: string;
        selectedCurrSymbol: string
    };
    builderProps: {
        getBuilderData: any;
        translationsData: TranslationsType;
        domain: string;
        dbName: string
        selectedLocale: string
        currencies: Array<ICurrencies>;
        selectedCurrItems: {
            selectedCurrCode: string;
            selectedCurrRate: string;
            selectedCurrSymbol: string
        };
        isMobile: boolean,
        recaptchaActive: string,
        backOrderValue: string;
    };
    showBuilderData: boolean;
    showWishlist: boolean;
    showCart: boolean;
    requestFormInfo: IFormComponentType | null;
    recaptchaActive: string;
    requestFormDetails: IRequestFormDetails
}

const CustomShopProduct: FC<ICustomShopProduct> = (
    {
        dbName,
        domain,
        productSlug,
        selectedRate,
        product,
        backOrderValue,
        customerGroupPrices,
        translationsData,
        selectedLocale,
        schemaBrandName,
        showDetailsInFront,
        breadcrumb,
        relatedProducts,
        selectedCurrItems,
        builderProps,
        showBuilderData,
        showWishlist,
        showCart,
        requestFormInfo,
        recaptchaActive,
        requestFormDetails
    }
) => {
    const popupOpen = useSelector((state: IState) => state.formBuilder?.popup_open)
    const showBuilderComponents:
        (id: number) => Record<"true" | "false", ReactNode> = (id) => {
        return {
            "true": <BuilderSection tab={id} {...builderProps} />,
            "false": null
        }
    }
    const productProps = {
        backOrderValue,
        dbName,
        domain,
        translationsData,
        productSlug,
        selectedRate,
        product,
        selectedLocale,
        schemaBrandName,
        showDetailsInFront,
        showBuilderComponents,
        showBuilderData,
        showWishlist,
        requestFormInfo,
        requestFormDetails
    }

    const productShowHandle: Record<string, ReactNode> = {
        simple: <CustomProduct customerGroupPrices={customerGroupPrices} {...productProps}/>,
        configurable: <CustomConfig {...productProps} />,
        virtual: <CustomProduct customerGroupPrices={customerGroupPrices} {...productProps}/>,
        downloadable: <CustomDownloadableProduct {...productProps}/>,
        bundle: <CustomBundle customerGroupPrices={customerGroupPrices} {...productProps}/>
    }
    return (
        <Fragment>
            <BreadcrumbHeader breadcrumb={breadcrumb} dbName={dbName}/>
            {showBuilderComponents(1)[`${showBuilderData}`]}
            <div style={{margin: "50px auto"}}>
                <div className="container">
                    {productShowHandle[`${product.type}`]}
                </div>
            </div>
            {relatedProducts.length ? (
                <CustomRelatedBlock
                    title={translationsData?.RelatedProducts}
                    products={relatedProducts}
                    dbName={dbName}
                    translationsData={translationsData}
                    backOrderValue={backOrderValue}
                    selectedCurrItems={selectedCurrItems}
                    selectedLocale={selectedLocale}
                    showWishlist={showWishlist}
                    showCart={showCart}
                    loading="lazy"
                />
            ) : <Fragment />}
            {showBuilderComponents(3)[`${showBuilderData}`]}
            {requestFormInfo && popupOpen?.open && popupOpen?.id === requestFormInfo?.data?.id ? (
                <FormModal
                    productInfo={{
                        sku: product?.sku,
                        image: product?.images?.[0],
                        name: product?.flats?.[0]?.name
                    }}
                    title={requestFormDetails?.requestFormTitle}
                    form={{formComponentInfo: requestFormInfo, customClassNames: ""}}
                    recaptchaActive={recaptchaActive}
                />
            ) : null}
        </Fragment>
    )
};

export default CustomShopProduct
